import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';

// Browsers change a focused <input type="number">'s value when the user
// scrolls over it — nothing else on the page has to be listening, the
// browser does it natively on the focused element. That's rarely wanted (a
// numeric field mid-form silently changing under an unrelated page scroll),
// so blur it the moment a wheel event reaches it; the browser only adjusts
// the value while the element is focused, so this stops the adjustment
// without needing to touch every numeric input in the app individually.
document.addEventListener(
  "wheel",
  () => {
    const el = document.activeElement;
    if (el instanceof HTMLInputElement && el.type === "number") {
      el.blur();
    }
  },
  { passive: true }
);

// Offline app shell + push notifications (src/service-worker.js). Production
// builds only — `npm start` serves no worker.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
